/**
 * Registry rerankerjev — SAMO metapodatki (client-safe, brez fs/logger/
 * transformers importov; runtime je v lib/chat/rerank.ts).
 * Vzorec CHAT_MODELS: id → meta, resolve z varnim privzetkom 'none'.
 *
 * Lab meritve (docs/eval/RERANK_LATENCY_2026-07-22.md + RERANK_AB_*):
 *   - CE (bge-base/v2-m3): pod baselineom (article −5,3/−6,3 pp) — opt-in
 *     eksperiment za PoC, ne priporočen privzetek.
 *   - flash (LISTWISE Gemini, seja 279): edini NAD baselineom — golden v3
 *     Combined R@5 +9,3 pp, Article R@5 +7,4 pp. Mostiček na Gemini infri,
 *     NE za DRO/suvereno pot (Vertex odvisnost).
 */

export type RerankerId = 'none' | 'bge-base' | 'bge-v2-m3' | 'flash';

export interface RerankerMeta {
  /** 'ce' = lokalni cross-encoder (transformers.js); 'llm' = en listwise LLM klic. */
  kind: 'ce' | 'llm';
  /** HF model id — samo kind 'ce'. */
  modelId?: string;
  /** ONNX kvantizacija — samo kind 'ce'. */
  dtype?: 'int8' | 'fp32';
  label: string;
  description: string;
}

export const RERANKERS: Record<Exclude<RerankerId, 'none'>, RerankerMeta> = {
  'bge-base': {
    kind: 'ce',
    modelId: 'Xenova/bge-reranker-base',
    dtype: 'int8',
    label: 'bge-reranker-base',
    description: 'mali CE (278M, ~54 ms/par CPU); lab A/B: −5,3 pp — eksperimentalno',
  },
  'bge-v2-m3': {
    kind: 'ce',
    modelId: 'onnx-community/bge-reranker-v2-m3-ONNX',
    dtype: 'int8',
    label: 'bge-reranker-v2-m3',
    description: 'veliki CE (568M, ~175 ms/par CPU); lab A/B: −6,3 pp — eksperimentalno',
  },
  flash: {
    kind: 'llm',
    label: 'Gemini Flash (listwise)',
    description: 'en LLM klic nad celim naborom (~1–2 s); lab A/B: Combined +9,3 pp, Article R@5 +7,4 pp — edini nad baselineom',
  },
};

export function resolveRerankerId(id?: string | null): RerankerId {
  return id === 'bge-base' || id === 'bge-v2-m3' || id === 'flash' ? id : 'none';
}
